import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/_work/holibob/holibob/booking-web/contexts/ApolloProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Providers"] */ "/home/runner/_work/holibob/holibob/booking-web/contexts/Providers.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["useViewer"] */ "/home/runner/_work/holibob/holibob/booking-web/hooks/useViewer.ts");
;
import(/* webpackMode: "eager" */ "/home/runner/_work/holibob/holibob/node_modules/.pnpm/next@14.2.8_@babel+core@7.24.5_@opentelemetry+api@1.9.0_@playwright+test@1.48.2_babel-p_869e452061fd63b625d83764ba78353f/node_modules/next/dist/client/script.js");
